import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'
import SubmitButton from 'components/atoms/buttons/SubmitButton'

const styles = theme => ({
  root: {
    ...theme.components.popover,
  },
  content: {
    padding: `${theme.spacing(2)}px 0 ${theme.spacing(4)}px`,
  },
  description: {
    marginBottom: theme.spacing(1),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  actions: {
    maxWidth: 360,
    display: 'flex',
    margin: '0 auto',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
})

const DeletePeopleConfirm = ({ classes, data }) => (
  <div className={classes.root}>
    <Typography variant="h1">Delete users</Typography>
    <section className={classes.content}>
      <Typography className={classes.description}>
        Deleted users will not be able to view or collect
        <br />
        data for {data.organisationName}'s traps
      </Typography>
      <Typography className={classes.description}>
        Are you sure you want to remove{' '}
        {data.peopleCount > 1 ? `these ${data.peopleCount} users` : 'this user'}
        <br />
        from your project
      </Typography>
    </section>
    <div className={classes.actions}>
      <SubmitButton
        size="medium"
        color="primary"
        variant="secondary"
        onClick={data.onClose}>
        Cancel
      </SubmitButton>
      <SubmitButton
        size="medium"
        color="primary"
        variant="primary"
        onClick={data.onConfirm}>
        Confirm
      </SubmitButton>
    </div>
  </div>
)

DeletePeopleConfirm.propTypes = {
  data: PropTypes.object,
  classes: PropTypes.object,
  handleClose: PropTypes.func,
}

export default withStyles(styles)(DeletePeopleConfirm)



// WEBPACK FOOTER //
// ./src/components/molecules/DeletePeopleConfirm.js